import React from 'react';
import { WithPermissions, MenuItemLink } from "react-admin";
import LinkIcon from '@material-ui/icons/Link';

import accounts from "../../accounts";
import ambassador from "../../ambassador";
import SubMenu from "../SubMenu";

// Support Menu
export const SupportSideMenu = ({ handleToggle, menuBusiness, menuDocs, menuCatalog, open, translate, onMenuClick }) => (
    <WithPermissions
        render={({ permissions }) => (
            permissions === 'support'
                ? <>
                    <MenuItemLink
                        to={`/accounts`}
                        primaryText={translate(`resources.accounts.name`, {
                            smart_count: 2
                        })}
                        leftIcon={<accounts.icon />}
                        onClick={onMenuClick}
                     />
                     <MenuItemLink
                        to={`/invitation-link`}
                        primaryText="Invitation Link"
                        leftIcon={<LinkIcon/>}
                        onClick={onMenuClick}
                    />
                    <SubMenu
                        handleToggle={() => handleToggle("menuBusiness")}
                        isOpen={menuBusiness}
                        sidebarIsOpen={open}
                        name="pos.menu.ambassador"
                        icon={<ambassador.icon />}
                    >
                        <MenuItemLink
                            to={`/user/ambassador/posts`}
                            primaryText={translate(`resources.posts.name`)}
                                leftIcon={<ambassador.postIcon />}
                                onClick={onMenuClick}
                        />
                        <MenuItemLink
                            to={`/user/ambassador/commissions`}
                            primaryText={translate(`resources.commissions.name`)}
                            leftIcon={<ambassador.commissionIcon />}
                            onClick={onMenuClick}
                        />
                    </SubMenu>
                </>
                : null
        )}
    >
    </WithPermissions>
)